module.exports = __webpack_public_path__ + "img/eductorenviro_stopped.4eb19ab3.svg";